import React from "react";
import CircleIcon from '@mui/icons-material/Circle';



export default function TrafficlightButtonBlue() {
return(

    <CircleIcon sx={{fontSize: '170%', color: 'primary.main' }} />
)
}